<script setup>
import { t } from '../lib/i18n.mjs'
import { ref, onMounted, onUnmounted } from 'vue'
import AppIcon from './AppIcon.vue'
defineProps({ title: String, eyebrow: String, wide: Boolean })
const emit = defineEmits(['close'])
const panel = ref(null)
let previous
function keydown(event) {
  if (event.key === 'Escape') emit('close')
  if (event.key !== 'Tab') return
  const items = [...panel.value.querySelectorAll('button, input, select, textarea, [tabindex="0"]')].filter(
    (el) => !el.disabled && el.offsetParent,
  )
  const first = items[0],
    last = items[items.length - 1]
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault()
    last?.focus()
  }
  if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault()
    first?.focus()
  }
}
onMounted(() => {
  previous = document.activeElement
  panel.value.querySelector('input, select, textarea, button')?.focus()
  document.addEventListener('keydown', keydown)
})
onUnmounted(() => {
  document.removeEventListener('keydown', keydown)
  previous?.focus()
})
</script>
<template>
  <Teleport to="body">
    <div class="modal-backdrop" @mousedown.self="emit('close')">
      <section
        ref="panel"
        class="modal"
        :class="{ wide }"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <header class="modal-header">
          <div>
            <span class="eyebrow">{{ eyebrow }}</span>
            <h2 id="modal-title">{{ title }}</h2>
          </div>
          <button class="icon-button" :title="t('关闭')" :aria-label="t('关闭')" @click="emit('close')">
            <AppIcon name="X" />
          </button>
        </header>
        <slot />
      </section>
    </div>
  </Teleport>
</template>
